<template>
  <div class="animated fadeIn">
    <div id="Dashboard">
      <b-card>
        <b-card-header>
          <i class="icon-puzzle"></i>Tabela etykiet
          <div class="card-header-actions">

          </div>
        </b-card-header>
        <b-card-body>
          <v-server-table id="labelTable" ref="labelTable" :url="apiUrl" :columns="columns" :options="options">
            <div slot="color" slot-scope="props">
              <b-badge :style="{ 'background-color': props.row.color }" variant="primary">{{ props.row.color }}</b-badge>
            </div>
            <div slot="containInvoice" slot-scope="props">
              {{ props.row.containInvoice ? 'Tak': 'Nie'}}
            </div>
            <div slot="actions" slot-scope="props">
              <b-button @click="editModal(props.row)" size="sm" variant="primary">
                <i class="fa fa-edit"></i>
              </b-button>
              <b-button @click="removeLabel(props.row._id)" style="margin-left: 2px" size="sm" variant="danger">
                <i class="fa fa-remove"></i>
              </b-button>
            </div>
          </v-server-table>
        </b-card-body>
      </b-card>
    </div>

    <b-modal cancel-title="Wyjdź" ok-title="Zatwierdź" title="Edycja etykiety" size="lg" v-model="editModalVisible" @ok="editLabels">
      <b-form>
        <b-row v-for="(row, index) in formRows" :key="index">
          <b-col sm="3">
            <multiselect placeholder="Wybierz pola" :options="fieldsOptions" :multiple="true" v-model="row.selectedFields"></multiselect>
          </b-col>
          <b-col sm="3">
            <multiselect placeholder="Warunki" :options="conditionsOptions" v-model="row.selectedConditions"></multiselect>
          </b-col>
          <b-col sm="3">
            <b-input type="text" placeholder="Wartość" v-model="row.value"></b-input>
          </b-col>
          <b-col v-if="formRows.length > 1 && index != formRows.length - 1" sm="2">
            <b-form-select :options="['oraz', 'lub']" v-model="row.operator"></b-form-select>
          </b-col>
          <b-col v-if="index > 0" sm="1">
            <i @click="removeRow(index)" class="fa fa-remove"></i>
          </b-col>
        </b-row>
        <br>
        <b-row>
          <b-col sm="2">
            <b-form-group label="Nigdy nie zawiera faktury:" label-for="checkboxes" :label-cols="2">
              <b-form-checkbox :value="true" v-model="label.containInvoice"></b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <b-button @click="addRow" type="button" variant="primary">
          <i class="fa fa-plus"></i> Dodaj wiersz</b-button>
      </b-form>

      <hr>
      <b-row>
        <b-col sm="2">
          <b-input v-model="label.name" type="text" placeholder="Nazwa etykiety"></b-input>
        </b-col>
        <b-col sm="2">
          <b-input v-model="label.color" type="text" placeholder="Kolor etykiety"></b-input>
        </b-col>
        <b-col sm="3">
          <multiselect id="years" placeholder="Zakres etykiety" :options="['Koszt', 'Projekt']" v-model="label.scope"></multiselect>
        </b-col>
      </b-row>
    </b-modal>

    <Loading :loading="loading.processing" :text="loading.text"></Loading>

  </div>
</template>

<script>
import Vue from "vue";
import * as axios from "axios";
import { ClientTable, ServerTable, Event } from "vue-tables-2";

Vue.use(ServerTable);

import Multiselect from "vue-multiselect";
import Loading from "@/components/loading.vue";

import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

function toast({ title, message, type, timeout, cb }) {
  return miniToastr[type](message, title, timeout, cb);
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};
//  VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options);

export default {
  name: "DataTable",
  components: {
    ServerTable,
    Event,
    Multiselect,
    Loading
  },
  computed: {
    apiUrl() {
      return process.env.VUE_APP_API_URL + "/labels";
    }
  },
  methods: {
    editModal(label) {
      this.formRows = [];
      const andCondtitions = label.condition.split(" and ");
      andCondtitions.map(condition => {
        const orConditions = condition.split(" or ");
        orConditions.map((cd, index) => {
          cd = cd.split(" ");
          this.formRows.push({
            selectedFields: this.fieldsReverseMap[cd[0]],
            selectedConditions: this.conditionsReverseMap[cd[1]],
            value: cd.slice(2, cd.length).join(" "),
            operator: index == orConditions.length - 1 ? "oraz" : "lub"
          });
        });
      });

      this.label._id = label._id;
      this.label.name = label.name;
      this.label.scope = label.scope;
      this.label.color = label.color;
      this.label.containInvoice = label.containInvoice
      this.editModalVisible = true;
    },
    editLabels() {
      const self = this;
      let condition = "";

      this.formRows.map((row, index) => {
        
        if (row.selectedFields.constructor !== Array) {
          row.selectedFields = row.selectedFields.split(',')
        }
        row.selectedFields.forEach((field, index) => {
          let mappedField = self.fieldsMap[field];
          let mappedCondition = self.conditionsMap[row.selectedConditions];

          condition += `${mappedField} ${mappedCondition} ${row.value}`;

          if (index != row.selectedFields.length - 1) {
            condition += " or ";
          }
        });

        if (index != this.formRows.length - 1) {
          condition += ` ${self.operatorMap[row.operator]} `;
        }
      });

      self.label.condition = condition;
      
      self.editModalVisible = false;
      this.loading.processing = true;
      this.loading.text = "Edycja etykiety...";
  
      axios
        .post(`${process.env.VUE_APP_API_URL}/labels/edit`, { labelData: self.label })
        .then(res => {
          this.$refs.labelTable.refresh();
          this.loading.processing = false;
          this.loading.text = "";
          this.showSuccessEditMsg();
        })
        .catch(err => {
          this.showError();
        });
    },
    removeLabel(id) {
      this.loading.processing = true;
      this.loading.text = "Usuwanie etykiety...";

      axios
        .delete(`${process.env.VUE_APP_API_URL}/labels`, { params: { id: id } })
        .then(res => {
          this.$refs.labelTable.refresh();
          this.loading.processing = false;
          this.loading.text = "";
          this.showSuccessRemoveMsg();
        })
        .catch(err => {
          this.loading.processing = false;
          this.loading.text = "";
          this.showError();
        });
    },
    addRow() {
      this.formRows.push({
        selectedFields: null,
        selectedConditions: null,
        value: "",
        operator: "lub"
      });
    },
    removeRow(index) {
      this.formRows.splice(index, 1);
    }
  },
  data: function() {
    return {
      loading: {
        processing: false,
        text: ""
      },
      fieldsOptions: [
        "Id",
        "Nadawca/Odbiorca",
        "Tytuł",
        "Numer konta",
        "Kwota",
        "Saldo",
        "Data operacji",
        "Data księgowania",
        "Opis"
      ],
      conditionsOptions: [
        "Równe",
        "Zawiera",
        "RegEx",
        "Nie Równe",
        "Nie zawiera",
        "Mniejsze od",
        "Mniejsze bądź równe",
        "Większe od",
        "Większe bądź równe"
      ],
      conditionsMap: {
        Równe: "equals",
        Zawiera: "contains",
        RegEx: "matches-RegEx",
        "Nie Równe": "does-not-equal",
        "Nie zawiera": "does-not-contain",
        "Mniejsze od": "less-then",
        "Mniejsze bądź równe": "less-then-or-equal",
        "Większe od": "greater-then",
        "Większe bądź równe": "greater-then-or-equal"
      },
      conditionsReverseMap: {
        equals: "Równe",
        contains: "Zawiera",
        "matches-RegEx": "RegEx",
        "does-not-equal": "Nie Równe",
        "does-not-contain": "Nie zawiera",
        "less-then": "Mniejsze od",
        "less-then-or-equal": "Mniejsze bądź równe",
        "greater-then": "Większe od",
        "greater-then-or-equal": "Większe bądź równe"
      },
      fieldsMap: {
        Id: "id",
        "Nadawca/Odbiorca": "sender/recipient",
        Tytuł: "title",
        "Numer konta": "account_number",
        Kwota: "amount",
        Saldo: "saldo",
        "Data operacji": "operation_date",
        "Data księgowania": "accounting_date",
        Opis: "description"
      },
      fieldsReverseMap: {
        id: "Id",
        "sender/recipient": "Nadawca/Odbiorca",
        title: "Tytuł",
        account_number: "Numer konta",
        amount: "Kwota",
        saldo: "Saldo",
        operation_date: "Data operacji",
        accounting_date: "Data księgowania",
        description: "Opis"
      },
      operatorMap: {
        oraz: "and",
        lub: "or"
      },
      formRows: [],
      label: {
        name: "",
        color: "",
        scope: "Koszt"
      },
      editModalVisible: false,
      columns: ["_id", "name", "condition", "color", "scope", "containInvoice", "actions"],
      data: [],
      options: {
        requestFunction: function(data) {
          return this.axios
            .get(this.url, {
              params: data
            })
            .catch(
              function(e) {
                this.dispatch("error", e);
              }.bind(this)
            );
        },
        headings: {
          _id: "Id",
          name: "Nazwa",
          condition: "Warunek",
          color: "Kolor",
          scope: "Zakres",
          actions: "Akcje",
          containInvoice: "Zawsze bez faktury",
        },
        sortable: ["name", "condition", "color"],
        filterable: ["name", "condition", "color"],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          chunk: 5,
          edge: false,
          nav: "scroll"
        },
        responseAdapter: function(resp) {
          var data = resp.data;
          return { data: data.data, count: data.count };
        }
      },
      useVuex: false,
      theme: "bootstrap4",
      template: "default"
    };
  },
  notifications: {
    showSuccessRemoveMsg: {
      type: VueNotifications.types.success,
      title: "Sukces",
      message: "Pomyślnie usunięto etykietę."
    },
    showSuccessEditMsg: {
      type: VueNotifications.types.success,
      title: "Sukces",
      message: "Pomyślnie zedytowano etykietę."
    },
    showError: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Nie udało się usunąć etykiety."
    }
  }
};
</script>

<style lang="scss">
#labelTable {
  width: 95%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.25rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
